module.exports = __webpack_public_path__ + "static/media/lemouv.320c54f3.png";